import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorIcon } from '@/assets/icons/error';
import { Box } from '@/components/lib/components';
import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';

export const useBetUnconfirmedAlert = () => {
    const { t } = useTranslation(['betslip_sbk', 'common']);
    const { showInfoSheet } = useAlerts();
    const isPredictions = useIsPredictionsProduct();
    const showBetUnconfirmedAlert = useCallback(() => {
        showInfoSheet({
            title: t(isPredictions ? 'trade_not_confirmed' : 'entry_not_confirmed'),
            description: t(isPredictions ? 'trade_not_confirmed_description' : 'entry_not_confirmed_description'),
            buttonLabel: t('common:got_it'),
            icon: (
                <Box mt="s16">
                    <ErrorIcon />
                </Box>
            ),
        });
    }, [showInfoSheet, t, isPredictions]);
    return { showBetUnconfirmedAlert };
};
